import { z } from 'zod';
import { isISOString } from './validation/iso8601.js';
export const HitpointsEvent = z.object({
    id: z.string().uuid(),
    entityId: z.string().uuid(),
    version: z.number().int().min(1).optional(),
    type: z.string().min(3),
    timestamp: z.string().refine(isISOString, { message: 'Unexpected timestamp format' }),
});
//# sourceMappingURL=event.js.map